import React from 'react';
import {useMediaQuery} from '@mui/material';
import {alpha, useTheme} from '@mui/material/styles';

const MedicalPageLayout = ({currentStep, title, subtitle, children, footer}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return <div style={{
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflowX: 'clip',
    '--travel-medical-mobile-question-size': theme.typography.pxToRem(13.5),
    '--travel-footer-background': theme.palette.background.paper,
    '--travel-footer-shadow': `0 -6px 20px ${alpha(theme.palette.secondary.dark, 0.1)}`,
    '--medical-divider': theme.palette.divider,
    '--medical-surface': theme.palette.background.paper,
    '--medical-expanded-surface': theme.palette.background.default,
    '--medical-primary': theme.palette.primary.main,
    '--medical-primary-dark': theme.palette.primary.dark,
    '--medical-primary-soft': theme.palette.primary.lighter,
    '--medical-secondary': theme.palette.secondary.main,
    '--medical-secondary-dark': theme.palette.secondary.dark,
    '--medical-text': theme.palette.text.primary,
    '--medical-muted-text': theme.palette.text.secondary,
    '--medical-error': theme.palette.error.main,
    '--medical-focus-ring': alpha(theme.palette.secondary.main, 0.45),
    '--medical-font-family': theme.typography.fontFamily,
    '--medical-question-size': theme.typography.pxToRem(15.5),
    '--medical-detail-size': theme.typography.pxToRem(13.5),
    '--medical-followup-title-size': theme.typography.pxToRem(17),
    '--medical-weight-semibold': theme.typography.fontWeightSemiBold,
    '--medical-weight-bold': theme.typography.fontWeightBold,
    '--medical-weight-black': theme.typography.fontWeightBlack,
    '--medical-card-shadow': theme.shadows[4],
  }}>
    <main style={{
      position: 'relative',
    zIndex: 1,
    flex: '1 1 auto',
      display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
      padding: 'clamp(14px, 2vw, 22px) clamp(18px, 4vw, 48px) 18px',
      maxWidth: 1180,
    margin: '0 auto',
    width: '100%',
    }}>
      <section className='medical-page-content'>
        {title && (
          <h1 style={{
            margin: 0,
            fontWeight: theme.typography.fontWeightBlack,
            fontSize: theme.typography.pxToRem(isMobile ? 26 : 34),
            letterSpacing: 0,
            color: theme.palette.secondary.main,
            lineHeight: 1.15,
            textAlign: 'center',
            textWrap: 'balance',
          }}>
            {title}
            <span
              style={{
                display: 'inline-block',
                width: '.24em',
                height: '.24em',
                borderRadius: '50%',
                background: theme.palette.primary.dark,
                marginInlineStart: '.08em',
                verticalAlign: 'baseline',
              }}
              aria-hidden='true'
            />
          </h1>
        )}
        {subtitle && (
          <p data-testid='medical-subtitle' style={{
            margin: '10px auto 0',
            fontSize: theme.typography.pxToRem(isMobile ? 14 : 16),
            color: theme.palette.text.secondary,
            lineHeight: 1.5,
            textAlign: 'center',
            maxWidth: '100%',
            textWrap: 'balance',
          }}>
            {subtitle}
          </p>
        )}
        <div className='medical-question-card'>
          {children}
        </div>
        {footer}
      </section>
    </main>
  </div>;
};

export default MedicalPageLayout;
